import { error, finish } from '../../../modules/liabilities/actions/alerts';
import api from '../../../api';

export function request(dispatch) {
    api.get('/liabilities-alerts/liability-limit', void 0).then(
        result => dispatch(finish( result ? result.selections : [])),
        errors => dispatch(error(errors))
    );
}
